export default "__VITE_ASSET__B4iO7TWi__"